import React from "react";
import { IconButton, Paper, TextField } from "@material-ui/core";
import { Clear, Search } from "@material-ui/icons";

const FilterDataTable = ({ query, setQuery, search }) => {
  return (
    <Paper style={{ width: "100%", maxWidth: '400px' }}>
      <TextField
        fullWidth
        id="autocomplete_filter_input"
        size="small"
        variant="outlined"
        name="query"
        value={query}
        placeholder="Search..."
        autoFocus
        onChange={(e) => setQuery(e.target.value)}
        inputProps={{ autoComplete: "off" }}
        onKeyDown={(e) => e.key === "Enter" && search()}
        InputProps={{
          endAdornment: (
            <>
              {query && (
                <IconButton
                  id="clear_automplete_input_btn"
                  size="small"
                  onClick={() => setQuery("")}
                >
                  <Clear />
                </IconButton>
              )}
              <Search />
            </>
          ),
        }}
      />
    </Paper>
  );
};

export default FilterDataTable;
